import React from 'react';
import { motion } from 'framer-motion';
import { articles } from '../data/articles';
import { ArrowRight } from 'lucide-react';
export function FeaturedArticles() {
  return <section id="featured" className="py-20 bg-white" data-id="element-95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-96">
        <div className="text-center mb-16" data-id="element-97">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-navy mb-4" data-id="element-98">
            From the Archive
          </h2>
          <p className="text-lg text-brand-slate max-w-2xl mx-auto" data-id="element-99">
            Explore our most popular deep dives into productivity, focus, and
            strategy.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-100">
          {articles.map((article, index) => <motion.a key={article.id} href={article.url} target="_blank" rel="noopener noreferrer" className="group block bg-brand-cream rounded-xl p-8 border border-transparent hover:border-brand-gold/30 hover:shadow-lg transition-all duration-300 relative overflow-hidden" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} data-id="element-101">
              <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-102">
                <ArrowRight size={48} className="-rotate-45 text-brand-navy" data-id="element-103" />
              </div>

              <div className="flex items-center gap-3 mb-4" data-id="element-104">
                <span className="px-3 py-1 bg-white text-brand-navy text-xs font-semibold uppercase tracking-wider rounded-full border border-gray-100" data-id="element-105">
                  {article.category}
                </span>
                <span className="text-sm text-gray-500" data-id="element-106">{article.date}</span>
              </div>

              <h3 className="text-2xl font-serif font-bold text-brand-navy mb-3 group-hover:text-brand-gold transition-colors" data-id="element-107">
                {article.title}
              </h3>

              <p className="text-brand-slate mb-6 leading-relaxed" data-id="element-108">
                {article.excerpt}
              </p>

              <div className="flex items-center text-brand-navy font-medium group-hover:translate-x-2 transition-transform duration-300" data-id="element-109">
                Read Article <ArrowRight size={16} className="ml-2" data-id="element-110" />
              </div>
            </motion.a>)}
        </div>
      </div>
    </section>;
}